import { makeStyles } from "@material-ui/core"

export default makeStyles(theme => ({
    indexRoot: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        backgroundColor: theme.palette.background.paper
    },
    grayText: {
        color: "#666"
    },
    listRoot: {
        display: "flex",
        flexWrap: "wrap",
        backgroundColor: theme.palette.background.paper
    },
    root: {
        marginLeft: "10px",
        marginRight: "10px"
    },
    image: {
        height: 200,
        width: 300
    },
    card: {
        height: "auto",
        width: 300,
        border: "none",
        boxShadow: "none"
    }
}))
